import { useDispatch } from 'react-redux';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

/**
 * `useDispatch` con el tipo de redux-thunk: `dispatch(thunk)` devuelve lo que
 * devuelve el thunk (en los ducks, una promesa). Con el `useDispatch` sin tipar
 * el análisis estático cree que devuelve la acción y marca cada `await`.
 */
export type AppDispatch = ThunkDispatch<unknown, unknown, AnyAction>;

export const useAppDispatch = (): AppDispatch => useDispatch<AppDispatch>();
